import { fork, all } from 'redux-saga/effects'
import commonSaga from 'Store/common/common.saga'
import orderSaga from 'Store/orders/saga'
import productSaga from 'Store/product/saga'
import posSaga from 'Store/pos/saga'

function* rootSaga() {
  yield all([fork(commonSaga), fork(orderSaga), fork(productSaga), fork(posSaga)])
}

export default rootSaga
